import { DashboardWrapper } from "../../container/dashboardWrapper"
import { Link } from 'react-router-dom';
import {
    Container,
    Heading,
    ContentWrapper,
    OverviewSection,
    Grid,
    ExamAndSubjectContainer,
    AnnouncementContainer
} from "../../styles/dashboard";
import { RecentActivities } from "../../components/dashboard-overview/overview-recent-activities-card";
import { TasksPending } from "../../components/dashboard-overview/overview-tasks-pending-card";
import { ExamList } from "../../components/dashboard-exam-list/dashboard-exam-list";
import { Subjects } from "../../components/dashboard-subjects/dashboard-subjects";
import { Announcements } from "../../components/dashboard-announcements";
import { ModuleHeader } from "../../components/module-header";

const Dashboard = () => {
    return (
        <DashboardWrapper>
            <ContentWrapper>
                <Container>
                    <Heading>Welcome, Bidemi</Heading>
                    <OverviewSection>
                        <ModuleHeader title="overview" />
                        <Grid>
                            <RecentActivities />
                            <TasksPending />
                        </Grid>
                    </OverviewSection>
                    <ExamAndSubjectContainer>
                        {/* <Grid> */}
                        <ExamList />
                        {/* <Subjects /> */}
                        {/* </Grid> */}

                    </ExamAndSubjectContainer>
                    <AnnouncementContainer>
                        <ModuleHeader title="Announcements" />
                        <Announcements scroll />
                    </AnnouncementContainer>
                </Container>
            </ContentWrapper>
        </DashboardWrapper>
    )
}

export default Dashboard
